import React from "react";
import JourneyFlow from "./JourneyFlow";

// Les parcours produit, tous rendus par le même composant piloté par l'API.
// Un seul domaine pour ads / A-B / Shopify / tracking ; la partie vidéo vit
// sur cinemastudio.onebotads.net (le serveur détecte le sous-domaine).

export const AdsJourney = () => (
  <div className="p-2">
    <JourneyFlow source="ads" title="🚀 Créer une publicité" />
  </div>
);

export const AbTestingJourney = () => (
  <div className="p-2">
    <JourneyFlow source="ads" title="🧪 Marketing & A/B testing" />
  </div>
);

export const ShopifyJourney = () => (
  <div className="p-2">
    <JourneyFlow source="shopify" title="🛍️ Parcours marchand Shopify" />
  </div>
);

export const TrackingJourney = () => (
  <div className="p-2">
    <JourneyFlow source="tracking" title="🎯 Mettre en place le tracking" />
  </div>
);

export const CinemaStudioJourney = () => (
  <div className="p-2">
    <JourneyFlow source="cinema_studio" title="🎬 Parcours Cinema Studio" />
  </div>
);
